@if (patientManagementService.patientDto) {
  <div class="page-root">
    @if (mode == 'mobile') {
      <div class="page-one-column-body">
        <div class="mobile">
          <router-outlet/>
        </div>
      </div>
    } @else {
      <div class="page-two-column-body">
        <div class="page-row">
          <div class="column">

            <div class="title">
              <div class="typo-h1">
                {{ patientManagementService.patientDto.firstName }} {{ patientManagementService.patientDto.lastName }}
              </div>
            </div>

            <div class="menu">
              <button (click)="profile()" [class]="routeNumber == 0 ? 'selected-menu-item' : 'menu-item'" matRipple>
                <mat-icon>person</mat-icon>
                <div [class]="routeNumber == 0 ? 'body-text-bold selected-text wrap' : 'body-text-bold wrap'">{{ "appBar.profile" | transloco }}</div>
              </button>

              <mat-divider/>

              <button (click)="appointments()" [class]="routeNumber == 1 ? 'selected-menu-item' : 'menu-item'" matRipple>
                <mat-icon>accessibility_new</mat-icon>
                <div [class]="routeNumber == 1 ? 'body-text-bold selected-text wrap' : 'body-text-bold wrap'">{{ "appBar.appointments" | transloco }}</div>
              </button>

              <mat-divider/>
            </div>
          </div>

          <mat-divider class="primary" vertical/>

          <div class="flex">
            <router-outlet/>
          </div>
        </div>
      </div>
    }
  </div>
}
